import React, { useEffect, useState } from "react";
import SideDrawer from "../../../../components/sideDrower/SideDrawer";
import {
  feedCommentApi,
  feedCommentListApi,
  updateCommentApi,
} from "../../../../services/feeds";
import { toastMessage } from "../../../../utils/toastMessage";
import { LuSend } from "react-icons/lu";
import { avatar } from "assets";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";
import { deleteMessageApi } from "../../../../services/overview";
import { useSelector } from "react-redux";
import { uploadAttachmentApi } from "../../../../services/message";
import { timeAgo } from "../../../../utils/commonHelper";
import { IoImage } from "react-icons/io5";
import InfiniteScroll from "react-infinite-scroll-component";

const OverviewComment = ({
  show,
  close,
  selectedData = {},
  setCommentCount = () => {},
  pageName = "",
}) => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState({ content: "" });
  const [type, setType] = useState("");
  const [commentList, setCommentList] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [editMessage, setEditMessage] = useState(false);
  const [image, setImage] = useState([]);
  const fileRef = React.useRef(null);
  const inputRef = React.useRef(null);

  const handleText = (e) => {
    setContent({ ...content, content: e.target.value });
    setType("TEXT");
  };

  const fetchComments = async () => {
    if (!selectedData._id) return;
    try {
      const { data } = await feedCommentListApi({
        _feed: selectedData._id,
        limit: 10,
        page,
        pagination: true,
      });
      const { success, data: response, meta } = data;
      if (success) {
        setCommentList((prev) => [...prev, ...response]);
        setCommentCount(meta.totalRecords);
        if (page >= meta.totalPages) setHasMore(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, selectedData._id]);

  const addCommentHandler = async () => {
    if (!content.content.trim() && image.length === 0) {
      toastMessage("Comment cannot be empty!", "error", "addCommentOverview");
      return;
    }
    setLoading(true);
    try {
      let payLoad;
      console.log(content);
      if (editMessage) {
        payLoad = { content: content.content, type, _id: content.id };
        await updateCommentApi(payLoad);
        setCommentList((prev) =>
          prev.map((item) => {
            if (item._id === content.id) {
              return { ...item, content: content?.content };
            }
            return item;
          })
        );
      } else {
        payLoad =
          type === "MEDIA"
            ? {
                attachments: [{ url: image[0].url, type: "IMAGE" }],
                type,
                _feed: selectedData._id,
              }
            : { content: content.content, type, _feed: selectedData._id };
        const commentRes = await feedCommentApi(payLoad);
        setCommentList((prev) => [
          { ...commentRes?.data?.data, _user: showAuth },
          ...prev,
        ]);
      }

      setEditMessage(false);
      setContent({ content: "" });
      setType("");
      setImage([]);
    } catch (err) {
      console.error(err);
      toastMessage(
        "An error occurred. Please try again.",
        "error",
        "addCommentOverview"
      );
    } finally {
      setLoading(false);
    }
  };

  const editCommentHandler = (data) => {
    setContent({ content: data.content, id: data._id });
    setType(data.type);
    setEditMessage(true);
    inputRef?.current?.focus();
  };

  const deleteComment = async (id) => {
    try {
      const { data } = await deleteMessageApi({ _id: id });
      if (data.success) {
        toastMessage(data.message, "success", "deleteMessage");
        setCommentList(commentList.filter((item) => item._id !== id));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("attachments", file);
    try {
      const { data } = await uploadAttachmentApi(formData);
      const { success, data: res, message } = data;
      if (success && res.length) {
        setImage([
          {
            size: res[0].size,
            url: res[0].key,
            type: "IMAGE",
            showUrl: res[0].url,
          },
        ]);
        setType("MEDIA");
        setContent({ ...content, content: file.name });
      }
      toastMessage(message, success ? "success" : "error", "selectMedia");
    } catch (err) {
      console.error(err);
    }
  };

  const handleIconClick = () => fileRef.current.click();

  const resetComments = () => {
    // reset state and reload first page
    setCommentList([]);
    setPage(1);
    setHasMore(true);
  };

  return (
    <SideDrawer
      show={show}
      handleClose={() => {
        resetComments();
        close();
      }}
      className="user-comments-section"
    >
      <h3 className="drawer_title">Comments Overview</h3>
      {pageName === "Post" && (
        <p>
          <b>
            {pageName} Name : {selectedData?.title || ""}
          </b>
        </p>
      )}
      <div className="user_comments">
        <div id="comment_div" className="comment_section">
          <InfiniteScroll
            dataLength={commentList.length}
            next={() => setPage((p) => p + 1)}
            hasMore={hasMore}
            loader={<p>Loading...</p>}
            scrollableTarget="comment_div"
          >
            {commentList.map((data) => (
              <div key={data._id} className="commentt">
                <div className="top_content">
                  <div className="comment_img_content">
                    <img
                      src={data._user?.profilePicture || avatar}
                      className="avatar"
                      alt=""
                    />
                    <p>
                      <b>{data._user?.fullName}</b>
                      <span>{timeAgo(data.createdAt, Date.now())}</span>
                    </p>
                  </div>
                  {data._user?._id === showAuth._id && (
                    <Dropdown className="custom_dropdown">
                      <Dropdown.Toggle variant="success">
                        <BsThreeDotsVertical />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {data.type !== "MEDIA" && (
                          <Dropdown.Item
                            onClick={() => editCommentHandler(data)}
                          >
                            Edit
                          </Dropdown.Item>
                        )}
                        <Dropdown.Item onClick={() => deleteComment(data._id)}>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </div>
                {data.type === "MEDIA" ? (
                  <img src={data.attachments[0]?.url} alt="" />
                ) : (
                  <p>{data.content || "---"}</p>
                )}
              </div>
            ))}
          </InfiniteScroll>
        </div>
        <div className="comment_input">
          <input
            type="file"
            ref={fileRef}
            accept="image/*"
            hidden
            onChange={handleFileChange}
          />
          <IoImage
            className="fs-4 overview_imgselect"
            onClick={handleIconClick}
          />
          <input
            type="text"
            className="input_box"
            value={content.content || ""}
            name="content"
            placeholder="Write comment here..."
            onChange={handleText}
            disabled={type === "MEDIA"}
            onKeyDown={(e) =>
              e.key === "Enter" && !loading && addCommentHandler()
            }
            ref={inputRef}
          />
          <button
            className="send_button"
            onClick={addCommentHandler}
            disabled={loading}
          >
            <LuSend />
          </button>
        </div>
      </div>
    </SideDrawer>
  );
};

export default OverviewComment;
